import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const MicrositeKonfirmasiUbahPassword = () => {
	const navigate = useNavigate();

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);
	
	const toLandingPage = () => {
		navigate('/micrositeNews')
	};

	return (
		<Div className='page-wrapper'>

			<ContentWrapper>
				<Div className='content-padding'>
					<Div className='back-icon'>
						{/* <KeyboardBackspaceIcon /> */}
						<Div className='flex-justify-start' sx={{ marginLeft: '28px' }}>

						</Div>
					</Div>
					<Div className='mt-2'>
						<Typography sx={{ mt: 2 }} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Selamat! Password Anda berhasil diubah</Typography>
						<Div className='dis-flex-center' sx={{ mt: 2 }}>
							<img className='illust-state' src={`${process.env.REACT_APP_IMAGES_PATH}/AddleadsSukses.svg`} width={265} height={265} />
						</Div>

						<Div className='flex-justify-center' sx={{ mt: 2 }}>
							<ButtonStyled
								onClick={toLandingPage}
								btnText={"Oke"}
								sx={{ maxWidth: '451px' }}
							/>
						</Div>
					</Div>
				</Div>

			</ContentWrapper>
		</Div>

	);
};

export default MicrositeKonfirmasiUbahPassword;